type Entry = { tables: ReadonlySet<string>; cb: () => void };

const entries = new Set<Entry>();

/** Tell subscribers which tables changed (after a local or remote write). */
export function emitTables(tables: Iterable<string>): void {
  const changed = new Set(tables);
  for (const e of Array.from(entries)) {
    for (const t of changed) {
      if (e.tables.has(t)) {
        e.cb();
        break;
      }
    }
  }
}

export function onTables(tables: readonly string[], cb: () => void): () => void {
  const entry: Entry = { tables: new Set(tables), cb };
  entries.add(entry);
  return () => {
    entries.delete(entry);
  };
}
